import { Poker } from '@/components/common/poker';
import { DeckInfo, PokDengFullDeckInfo } from '@/models/games/pokdeng/DeckInfo';
import { parseDeckData } from '@/utils/games/pokdeng';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GameResultCellProps } from '..';

const Deck = (props: DeckInfo) => {
    const { position, card1, card2, point } = props;

    const { t } = useTranslation();

    const [positionLbl, setPositionLbl] = useState<string>('');
    const [positionLblColor, setPositionLblColor] = useState<string>('#F6444B');

    useEffect(() => {
        if (position == 0) {
            setPositionLblColor('#F6444B');
            setPositionLbl(t('pokdeng.dealer'));
        } else {
            setPositionLblColor('#3568EE');
            setPositionLbl(t(`pokdeng.player.${position - 1}`));
        }
    }, [position]);

    return (
        <div className="pokdeng-game-result-deck-container">
            <div className="poker-container">
                <div className="cards-container">
                    <div className="card">
                        <Poker n={card1} />
                    </div>
                    <div className="card">
                        <Poker n={card2} />
                    </div>
                </div>
            </div>
            <div className="info-container">
                <span style={{ color: positionLblColor }}>{positionLbl}</span>
                <span>{point}</span>
            </div>
        </div>
    );
};

export const PokDengGameResult = (props: GameResultCellProps) => {
    const { summary } = props;

    const [results, setResults] = useState<PokDengFullDeckInfo | null>(null);

    useEffect(() => {
        const parsedResults = parseDeckData(summary.Result);
        setResults(parsedResults);
    }, [summary]);

    return (
        <>
            {results && (
                <Box className="item-pokdeng-game-result-container">
                    <Box className="pokdeng-game-result-banker-container">
                        <Deck {...results.bankerDeck} />
                    </Box>
                    <Box className="pokdeng-game-result-player-container">
                        {results.playerDecks.map((deck, index) => {
                            return (
                                <Deck
                                    {...deck}
                                    key={`${deck.position}-${index}`}
                                />
                            );
                        })}
                    </Box>
                </Box>
            )}
        </>
    );
};
